import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=c116fee6&scoped=true&"
import script from "./MessageBox.vue?vue&type=script&lang=js&"
export * from "./MessageBox.vue?vue&type=script&lang=js&"
import style0 from "./MessageBox.vue?vue&type=style&index=0&id=c116fee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c116fee6",
  null
  
)

export default component.exports